<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Sub-Category Name </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="categoryName" name="search"></el-input>
            </div>
          </div>
          <div class="col-sm-4 textRight">
            <div class>
              <el-button type="primary" @click="search">{{
                $t("message.Search")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button
                    @click="gotoDetail"
                    v-if="checkPermission('SchoolResourcesCategory_LIST_ADD')"
                    >{{ $t("message.Add") }}</el-button
                  >
                  <el-button
                    @click="showWarning"
                    v-if="checkPermission('SchoolResourcesCategory_LIST_DEL')"
                    >{{ $t("message.Delete") }}</el-button
                  >
                </div>
              </div>
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="rows"
                class="rowss"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                row-key="id"
                :cell-class-name="cell"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="categoryNameEn" label="Sub-Category Name">
                </el-table-column>
                <el-table-column prop="categoryType" label="Category Type">
                  <template slot-scope="{row}">
                    {{categoryTypeMap[row.categoryType]}}
                  </template>
                </el-table-column>
                <el-table-column label="Action" width="70" fixed="right">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="24"
                        ><el-button
                          size="mini"
                          @click="handleDbClick(scope.row)"
                          icon="el-icon-edit"
                        ></el-button
                      ></el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";
import Sortable from "sortablejs";
import axios from "axios";
import StatusBtn from "../components/common/statusBtn.vue";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      name: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "",
      sortField: "",
      status: "",
      statusObj: [],
      typeObj: [],
      type: "",
      status: "",
      startDate: "",
      endDate: "",
      period: null,
      canDrag: true,
      categoryName: "",
    };
  },
  components: {
    StatusBtn,
  },
  computed:{
    categoryTypeMap(){
      return {
        1:'Document',
        2:'Video'
      }
    },
    baseURL() {
      return config.domain + "/";
    },
  },
  created: function () {},
  methods: {
    async init() {
      this.canDrag = true;
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.categoryName = this.categoryName;

      objdata.sortName = this.sortField;
      objdata.sortType = this.sortType;

      objdata.apiUrl = this.apiConfig.schoolResourcesCategoryList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.schoolResourcesCategory;
      this.setObj();
      this.total = data.data.result.total;
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 1;
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    cell: function ({ row }) {
      // if (!this.canDrag) {
      //   return "disabled pointer";
      // }
      // if (row.status == 1) {
      //   return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/schoolResourcesCategoryDetail",
        query: {
          id: row.id,
        },
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/schoolResourcesCategoryDetail" });
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(",");

      objdata.apiUrl = this.apiConfig.schoolResourcesCategoryDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    setObj: function () {
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
      ];
      this.typeObj = [
        {
          value: 0,
          label: "Broadcast message",
        },
        {
          value: 1,
          label: "Promotion",
        },
      ];
      let list = null;
      for (list of this.rows) {
        if (list.status === 0) {
          list.statusName = "Draft";
        } else if (list.status == 1) {
          list.statusName = "Pending approval";
        } else if (list.status == 2) {
          list.statusName = "Pending Publish";
        } else if (list.status == 3) {
          list.statusName = "Rejected";
        } else if (list.status == 4) {
          list.statusName = "Suspended";
        } else if (list.status == 5) {
          list.statusName = "Pending Suspend";
        } else if (list.status == 6) {
          list.statusName = "Published";
        }
      }
    },
    async updateConfirmedListSort(newIndex, oldIndex) {
      const userInfo=this.getAuthObj()
      const item = this.rows[oldIndex];
      this.rows.splice(oldIndex, 1);
      this.rows.splice(newIndex, 0, item);
      const lstOrderDTO = this.rows.map((i) => {
        return {
          id: i.id,
          displayOrder: i.sortOrder,
        };
      });
      const param = {
        lstOrderDTO,
        ...userInfo,
      };
      const {
        data: { status_code, status_message },
      } = await axios.post(this.baseURL + "schoolResourcesCategory/order", {
        ...param,
      });
      if (status_code == "0") {
        this.getConfirmedList();
      }else if(status_code=='000104'){
        this.timeoutEvent();
        return;
      }else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    }
  },
  mounted() {
    this.init();
     const table = document.querySelector(
        ".rowss .el-table__body-wrapper tbody"
      );
      const self = this;
      Sortable.create(table, {
        onEnd({ newIndex, oldIndex }) {
          self.updateConfirmedListSort(newIndex, oldIndex);
        },
        filter: ".disabled",
        onMove: (event) => {
          return !event.related.classList.contains("disabled");
        },
      });
  },
};
</script>
